/* eslint-disable */
import React, { useEffect, useState } from "react"
import AddToCartSidebar from "../DefaultGenericProductv2/AddToCartSidebar"
import { RiArrowDownSFill } from "react-icons/ri"

export default function SelectKitProducts({
  kitProductsState,
  values,
  setKitProducts,
  setImageIndex,
  forImageIndex,
  setCurrentProduct,
}) {
  const handleClick = (event, index) => {
    let selectedValue = values.filter(
      item => item[0].value === event.target.value,
    )?.[0]
    if (selectedValue) {
      let selectedIndex = values.indexOf(selectedValue)
      if (selectedIndex > -1) {
        setImageIndex(selectedIndex)
      }
    }
    let currentItem = [...kitProductsState] // create a new copy of the array
    currentItem = currentItem.map(item => {
      return { ...item, selected: false }
    })
    const counter = currentItem.filter(
      item =>
        item.metafields.filter(
          metafield => metafield?.value === event?.target?.value,
        ).length,
    )[0]
    let countIndex = currentItem.indexOf(counter)

    if (counter) {
      counter.selected = true
      currentItem[countIndex] = counter
      setCurrentProduct(currentItem[countIndex])
      setKitProducts([...currentItem])
      // setImageIndex && setImageIndex(countIndex + forImageIndex)
    }
  }

  return (
    <div>
      <div className="sticky top-0 right-0 hidden lg:block"></div>
      <div className="selectVariant relative border-[1px] border-[#1C1C1C] rounded-[53px] m-0 mt-1 w-full pointer">
        <select
          aria-label="Variants"
          className="relative appearance-none bg-transparent border-none text-obsidian pointer text-sm font-light m-0 pl-2 py-1 w-full"
          onChange={event => handleClick(event)}
        >
          <option value="">Select an option</option>
          {values?.map(value => (
            <option
              value={value[0].value}
              key={`${value[0].key}-${value[0].value}`}
            >
              {value[0].value}
            </option>
          ))}
        </select>
        <span className="block bg-no-repeat absolute top-1/2 right-2 -translate-y-1/2">
          <RiArrowDownSFill size={"28px"} />
        </span>
      </div>
    </div>
  )
}
